'use strict';

import {irregularityModel} from "../../models/irregularitymodel.js";
import {applicableMeasureModel} from "../../models/applicablemeasuremodel.js";

export class IrregularityInfoCtrl
{
	classif;
	
	model;
	
	allMeasures = [];
	
	removeUrl = '';
	
	constructor($scope, $http, $filter, $mdDialog, jsDataService){
		this.$scope = $scope;
		this.$http = $http;
		this.$filter = $filter;
		this.$mdDialog = $mdDialog;
		this.jsDataService = jsDataService;
		this.removeUrl = this.jsDataService.get('removeUrl', '');
		this.classif = jsDataService.get('cfgClassif');
		this.model = new irregularityModel(jsDataService.get('irregularity'), $filter, this.jsDataService);	
		this.allMeasures = this.model.applicable_measures;
		this.setApplicableMeasures();
//		this.removeUrl = '';
	}
	
	setApplicableMeasures() {
		this.model.applicable_measures = [];
		
		for(let ln of this.allMeasures){
			if(!this.model.applicable_measures_ids.includes(ln.measure)) {
				continue;
			}
			
			this.model.applicable_measures.push(new applicableMeasureModel(ln, this.$filter, this.jsDataService));
		}
	}
	
	openStatusDialog(ev){
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', 'jsDataService', this.projectStatusDialogCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'irregularities/status_dialog.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
			}
		}).then((status) => {
			if(this.jsDataService.get('cfgStatusUrl')){
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgStatusUrl'),
					method: 'POST',
					data: {
						status,
					}
				}).then((response) => {
					if(response.data.success){
						window.location.reload();
					}
				}, () => {});
			}
		}, (results) => {
		});
	}
	
	projectStatusDialogCtrl($scope, $mdDialog, jsDataService){
		const irregularity = jsDataService.get('irregularity');
		
		$scope.classif = jsDataService.get('cfgClassif', {});
		$scope.status = irregularity.status;
		
		$scope.close = function(){
			$mdDialog.cancel();
		};

		$scope.save = function(){
			$mdDialog.hide($scope.status);
		};

		$scope.isValid = function(){
			return $scope.status !== '';
		};
	}
	
	remove(ev){
		if(typeof(this.removeUrl) !== 'undefined' && this.removeUrl !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.removeUrl,
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
					if(results.data.success){

					}
				});
			}, () => {});
		}
	}
}